import { render, staticRenderFns } from "./batchDetail.vue?vue&type=template&id=1017b392&scoped=true"
import script from "./batchDetail.vue?vue&type=script&lang=js"
export * from "./batchDetail.vue?vue&type=script&lang=js"
import style0 from "./batchDetail.vue?vue&type=style&index=0&id=1017b392&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1017b392",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1017b392')) {
      api.createRecord('1017b392', component.options)
    } else {
      api.reload('1017b392', component.options)
    }
    module.hot.accept("./batchDetail.vue?vue&type=template&id=1017b392&scoped=true", function () {
      api.rerender('1017b392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/costManagement/components/batchDetail.vue"
export default component.exports